import format from 'date-fns/format'
import { DateString, TimeString } from 'config/format'

type ArrayValue = string | number | null | undefined

export const arrayToCsvText: (
  array: ArrayValue[][],
  newLine?: string
) => string = (array, newLine = '\r\n') => {
  function replace(value: string) {
    const isCrLf = newLine === '\r\n'
    const string = value.replace(/"/g, '""')
    return `"${isCrLf ? string.replace(/\n/g, '\r\n') : string}"`;
  }

  const body = array
    .map((arr: ArrayValue[]) => {
      return arr
        .map((value: ArrayValue) => {
          switch (typeof value) {
            case 'string':
              return replace(value)
            case 'number':
              return value
            default:
              return ''
          }
        })
        .join(',')
    })
    .join(newLine)
  return `${body}${newLine}`
}

export const csvFileName: (
  prefix?: string,
  dateTime?: Date,
  suffix?: string
) => string = (
  prefix = 'yadoc-quick-medical-institutions-',
  dateTime: Date = new Date(), // NOTE: ダウンロードした日時なのでクライアント内の時刻にした
  suffix = '.csv'
) => {
  return `${prefix}${format(dateTime, `${DateString}-${TimeString}`)}${suffix}`
}

export const downLoadCsvText = (csvText: string, fileName: string) => {
  let bom = new Uint8Array([0xef, 0xbb, 0xbf])
  let blob = new Blob([bom, csvText], { type: 'text/csv' })
  let url = (window.URL || window.webkitURL).createObjectURL(blob)
  let link = document.createElement('a')
  link.download = fileName
  link.href = url
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
